module.exports = __webpack_public_path__ + "static/media/trophy-cup.231fbea3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/trophy-cup.svg
// module id = 614
// module chunks = 1